import { ExternalPageMessages } from '../types';

export const externalZHTW: ExternalPageMessages = {
    'app.external.title.thankyou': '非常感谢您参加BEVI考评。',
    'app.external.thankyou_static_1_1': 'BEVI（the Beliefs, Events, and Values Inventory）是受著作权法保护的测试。BEVI及BEVI的结果、每道问题及其内容、还有各项比例标准，除非得到Craig N. Shealy博士的明确书面许可，否则无权对其全部或一部分进行分发、复制、变更、应用、公开或出版。',
    'app.external.thankyou_static_1_2': '以研究或教育为目的的BEVI中文版的使用权已由Craig N. Shealy博士授予西谷 元 教授（日本广岛大学）。',
    'app.external.thankyou_static_2': '与BEVI考评一样，此结果的构成和设计将会不断地被修订、改善。关于BEVI的考评及结果，若有意见与建议，请直接联系info@thebevi.com',
    'app.external.thankyou_static_3': '若想了解有关BEVI的更多详情，请查看International Beliefs and Values Institute（IBAVI）的主页（www.ibavi.org）及BEVI主页（thebevi.com）。',
}
